import {
  LayoutDashboard,
  ClipboardList,
  ClipboardCheck,
  Trophy,
  Users,
  Trophy as Circuit,
  DollarSign,
  Tags,
  Layers,
  Percent,
  MapPin,
  Award,
  Ticket,
  Package,
  FileText,
  Megaphone,
  Image as ImageIcon,
  Mail,
  Palette,
  Table2,
  Settings,
  ToggleLeft,
  UserCog,
  Camera,
  IdCard,
  Boxes,
  BedDouble,

} from "lucide-react";
import type { ShellNavGroup, ShellNavItem } from "@/components/shell/AppShell";

/**
 * Navigation for the ORG ADMIN area (white-label, single-organization scope).
 *
 * This mirrors the platform admin nav EXACTLY, except the PLATFORM group
 * (Organizations, Master Teams, Players) is removed — those are platform-wide
 * concerns the org admin should never see.
 *
 * Every screen reached here is scoped to the signed-in user's organization
 * (see AdminDashboardHome / the org-scoped list queries), so the org admin
 * gets the full toolset but only their own org's data.
 */
export const orgAdminNav: ShellNavGroup[] = [
  {
    items: [{ label: "Dashboard", href: "/admin-dashboard", icon: LayoutDashboard }],
  },
  {
    label: "Manage",
    items: [
      { label: "Events", href: "/admin-dashboard/events", icon: Trophy },
      { label: "Registrations", href: "/admin-dashboard/registrations", icon: ClipboardList },
      { label: "Shared Sheet Links", href: "/admin-dashboard/live-sheets", icon: Table2 },
      { label: "Teams", href: "/admin-dashboard/teams", icon: Users },
      { label: "Records", href: "/admin-dashboard/records", icon: ClipboardCheck },
      { label: "Circuits", href: "/admin-dashboard/circuits", icon: Circuit },
      { label: "Money", href: "/admin-dashboard/events/finance", icon: DollarSign },
      { label: "Staff", href: "/admin-dashboard/staff", icon: UserCog },
      { label: "Photos", href: "/admin-dashboard/photos", icon: Camera, badge: "Soon" },
      { label: "Coach Packets", href: "/admin-dashboard/coach-packets", icon: IdCard, badge: "Soon" },
    ],
  },
  {
    label: "More",
    items: [
      { label: "Resources", href: "/admin-dashboard/event-management", icon: Boxes, badge: "Soon" },
      { label: "Hotel Partners", href: "/admin-dashboard/hotel-partners", icon: BedDouble },
    ],
  },
  {
    label: "Setup",
    items: [
      { label: "Event Categories", href: "/admin-dashboard/event-categories", icon: Tags },
      { label: "Divisions", href: "/admin-dashboard/divisions", icon: Layers },
      { label: "Discount Policies", href: "/admin-dashboard/event-discount-policies", icon: Percent },
      { label: "Venues", href: "/admin-dashboard/venues", icon: MapPin },
      { label: "Sponsors", href: "/admin-dashboard/event-sponsors", icon: Award },
      { label: "Coupons", href: "/admin-dashboard/coupons", icon: Ticket },
      { label: "Extras Catalog", href: "/admin-dashboard/extras-catalog", icon: Package },
      { label: "Waivers", href: "/admin-dashboard/waivers", icon: FileText },
    ],
  },
  {
    label: "Advertising",
    items: [
      { label: "Banners & Ads", href: "/admin-dashboard/advertising", icon: Megaphone },
    ],
  },
  {
    label: "Communication",
    items: [
      { label: "Templates", href: "/admin-dashboard/communication/templates", icon: Mail },
      { label: "Branding (Headers & Footers)", href: "/admin-dashboard/communication/branding", icon: Palette },
    ],
  },
  {
    label: "Design",
    items: [
      { label: "Sport Cover Photos", href: "/admin-dashboard/sport-cover-photos", icon: ImageIcon },
    ],
  },
];

/** Pinned to the bottom of the sidebar — account/org settings only (no branding). */
export const orgAdminFooterNav: ShellNavItem[] = [
  { label: "Modules", href: "/admin-dashboard/modules", icon: ToggleLeft },
  { label: "Settings", href: "/admin-dashboard/settings", icon: Settings },
];
